// Safe Meta (Facebook) Pixel event helper. No-ops if the pixel isn't loaded.
export const fbTrack = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (e) { console.debug("fb pixel unavailable", e); /* pixel blocked or not loaded */ }
};
